import {defaultRouter, addRouter, myRouter} from '@/router/index'
import router from '@/router'
import global from '@/constants/Global.constants'
import i18n from '@/i18n/i18n'
const _import = require('@/router/import')//获取组件的方法
import axios from '@/request/http'
import Layout from '@/views/layout/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入
const routerData = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    setRouters: (state, routers) => {
      state.addRouters = routers // 保存动态路由用来addRouter
      state.routers = defaultRouter.concat(routers) // 所有有权限的路由表，用来生成菜单列表
    }
  },
  actions: {
    newRoutes ({commit}) {
      let user = JSON.parse(localStorage.getItem('user'))
      return new Promise((resolve, reject) => {
        axios.post(global.BASE_ACL + '/auth/findDetails?userInfoId='+ user.userInfoId + '&systemId=' + user.systemId).then(res => {
          let routeData = res.data.data
          let {accessedRouters, routeNameEN, routeNameCN} = filterAsyncRouter(routeData, {}, {})
          
          // 合并 sys 模块的静态路由
          accessedRouters = [...accessedRouters, ...myRouter]
          
          i18n.mergeLocaleMessage('en', {routeName: routeNameEN})
          i18n.mergeLocaleMessage('cn', {routeName: routeNameCN})
          
          resetRouter() // 重置路由
          router.addRoutes(accessedRouters) // 动态添加路由
          commit('setRouters', accessedRouters)
          resolve(accessedRouters)
        }).catch(error => {
          reject(error)
        })
      })

      function filterAsyncRouter(asyncRouterMap, routeNameEN, routeNameCN) { //遍历后台传来的路由字符串，转换为组件对象
        const accessedRouters = asyncRouterMap.filter(route => {
          route.path = route.code
          route.name = route.nameEn
          route.meta = {}
          route.meta.menuId = route.id
          routeNameEN[route.nameEn] = route.nameEn
          routeNameCN[route.nameEn] = route.nameCn
          if (route.componentUrl) {
            if (route.componentUrl === '/') {//Layout组件特殊处理
              route.component = Layout
            } else {
              route.component = _import(route.componentUrl)
            }
          }
          if (route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children, routeNameEN, routeNameCN).accessedRouters
          }
          return true
        })

        return {accessedRouters, routeNameEN, routeNameCN}
      }
    }
  }
}

export default routerData



// WEBPACK FOOTER //
// ./src/vuex/modules/routerData.js